/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Separate_DatesInputs */

const fr_label_separate_dates = /** @type {(inputs: Label_Separate_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séparer les dates`)
};

const en_label_separate_dates = /** @type {(inputs: Label_Separate_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate dates`)
};

/**
* | output |
* | --- |
* | "Separate dates" |
*
* @param {Label_Separate_DatesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_separate_dates = /** @type {((inputs?: Label_Separate_DatesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Separate_DatesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_separate_dates(inputs)
	return en_label_separate_dates(inputs)
});